import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { trackEvent } from '../services/events-tracker-service';

class TourStarter extends PureComponent {
    handleTourStartClick = () => {
        this.props.dispatch({
            type: 'TOUR_START_REQUESTED',
            payload: {
                stepId: 'general:firstProject'
            }
        });

        trackEvent('TOUR.START');
    }

    handleTourContinueClick = () => {
        this.props.dispatch({
            type: 'TOUR_START_REQUESTED',
            payload: {}
        });
    }

    handleTourRejectClick = () => {
        this.props.dispatch({ type: 'TOUR_REJECT_REQUESTED' });

        trackEvent('TOUR.REJECT');
    }

    render() {
        return (
            <div className="tour-starter">
                <div className="btn-group btn-group-auto">
                    {
                        this.props.rejected || this.props.completed ? (
                            this.props.rejected ? (
                                <button className="btn btn-secondary" disabled>Declined</button>
                            ) : (
                                <React.Fragment>
                                    <button className="btn btn-secondary" disabled>Tour Completed</button>

                                    <button className="btn btn-secondary btn-colored" onClick={this.handleTourStartClick}>See it again</button>
                                </React.Fragment>
                            )
                        ) : this.props.started ? (
                            <React.Fragment>
                                <button className="btn btn-secondary btn-colored" onClick={this.handleTourContinueClick}>Continue</button>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <button className="btn btn-secondary btn-colored" onClick={this.handleTourStartClick}>Yes, show me around</button>
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ tour }) => {
    return {
        rejected: tour.rejected,
        completed: tour.completed,
        started: tour.started
    };
};

export default connect(mapStateToProps)(TourStarter);
